import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col col-4" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = { class: "card-text" }

import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { guid } from "@app/Guid"
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineConnectorPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineConnectorPage',
  setup(__props) {

    document.title = "Configure connector"

    const tid = useOrganizationUnitId()
    const id = useId()

    const {
        useCurrentUserQuery,
        useConnectorsOfOrganizationQuery,
        usePipelineDetailsQuery,
        useAttachConnectorCommand
    } = useAdminConfigurePipelineConnectorPage()

    const connectorProviderElement = ref<HTMLIFrameElement>(null)

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const direction = computed(() => modelPipelineDetailsQueryV1.value?.Direction)
    const name = computed(() => `Connector for pipeline ${modelPipelineDetailsQueryV1.value?.Name}`)
    const configPageUrl = computed(() => `${provider.value?.ConfigPageUrl}${tid}`)
    const connectorProviderType = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderType)
    const connectorConfig = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorConfig)
    const connectorId = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorId)

    const { runConnectorsOfOrganizationQueryV1, modelConnectorsOfOrganizationQueryV1 } = useConnectorsOfOrganizationQuery(tid)
    const connectors = computed(() => modelConnectorsOfOrganizationQueryV1.value?.Connectors || [])

    const { invokeAttachConnectorCommandV1, succeedAttachConnectorCommandV1 } = useAttachConnectorCommand(id, tid, userId)

    watch(connectorProviderType, (val) => {
        providerType.value = connectorProviderType.value
    })

    watch(succeedAttachConnectorCommandV1, () => {
        if (succeedAttachConnectorCommandV1.value) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id}`
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorsOfOrganizationQueryV1()
        runPipelineDetailsQueryV1()
        window.addEventListener('message', onMessage);
    })

    onUnmounted(() => {
        window.removeEventListener('message', onMessage);
    })

    function onMessage(event) {
        if ((event.source as any)?.frameElement?.name == 'connectorProviderElement') {
            if (event.data?.type == 'Integrations.Connectors.ReadConfig') {
                // set current config once connector iframs is ready
                connectorProviderElement.value?.contentWindow?.postMessage({
                    'type': 'Integrations.Connectors.InitConfig',
                    'data': connectorConfig.value
                })
            }
            else if (event.data?.type == 'Integrations.Connectors.ApplyConnectorConfig') {
                config.value = JSON.stringify(event.data.data);
                invokeCreateConnectorCommandV1({ Id: connectorId.value })
            }
        }
    }

    function handleAttachConnectorCommandV1(connectorId: string) {
        invokeAttachConnectorCommandV1({ ConnectorId: connectorId })
    }

    function handleRefresh() {
        runConnectorsOfOrganizationQueryV1({ Rebuild: true })
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Configure connector", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5),
          _createElementVNode("a", {
            onClick: handleRefresh,
            class: "btn btn-link btn-sm"
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "fa fa-refresh",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Refresh ", -1 /* CACHED */)
          ]))])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectors.value, (c) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              onClick: ($event: any) => (handleAttachConnectorCommandV1(c.ConnectorId)),
              class: _normalizeClass(["card text-dark bg-light mb-3", { 'border-primary': connectorId.value == c.ConnectorId }]),
              role: "button"
            }, [
              (c.Provider?.LogoUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "card-img-top m-1",
                    src: c.Provider?.LogoUrl,
                    style: {"max-height":"100px"}
                  }, null, 8 /* PROPS */, _hoisted_10))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h5", _hoisted_12, _toDisplayString(c.Name), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_13, _toDisplayString(c.Description), 1 /* TEXT */)
              ])
            ], 10 /* CLASS, PROPS */, _hoisted_9)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}
}

})